/**
 * Cycle (Election) entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath } from '@electinfo/common';
import type { EntityConfig, EntitySearchResult } from './types';

class CycleIndex extends EntityIndex {
  getConfig(): EntityConfig {
    return {
      entityType: 'Cycle',
      placeholder: 'Search election cycles...',
      browseTitle: 'All Election Cycles',
      sortOrder: 'DESC',
      formatResult: (result: EntitySearchResult) => ({
        url: `/${canonicalPath('Cycle', result.name || result.id)}/`,
        name: result.name ? `${result.name} Election Cycle` : 'Election Cycle',
        meta: result.name ? `Federal election cycle ${result.name}` : ''
      })
    };
  }
}

new CycleIndex();
